var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 800,
    viewBox: "0 0 32 32"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "lock_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#lock_svg__a)",
    "data-name": "Group 2295"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2285"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2284"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2283"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2282"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2281"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2280"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2279"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2278"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2277"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#344952",
    d: "M25.668 11.543a1.2 1.2 0 0 0 .037-.289 9.705 9.705 0 1 0-19.41 0 1.3 1.3 0 0 0 .036.289 4.38 4.38 0 0 0-2.13 3.749v10.784a4.38 4.38 0 0 0 4.376 4.376h14.846a4.38 4.38 0 0 0 4.376-4.376V15.292a4.37 4.37 0 0 0-2.131-3.749M16 4.049a7.21 7.21 0 0 1 7.188 6.867H8.812A7.206 7.206 0 0 1 16 4.049m9.3 22.027a1.877 1.877 0 0 1-1.876 1.875H8.577a1.88 1.88 0 0 1-1.876-1.875V15.292a1.88 1.88 0 0 1 1.876-1.875h14.846a1.88 1.88 0 0 1 1.876 1.875Z",
    "data-name": "Path 3827"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2294"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2293"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2292"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2291"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2290"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2289"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2288"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2287"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2286"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#344952",
    d: "M18.343 19.513a2.344 2.344 0 1 0-3.789 1.832l-.428 4.074a.312.312 0 0 0 .311.345h3.138a.314.314 0 0 0 .313-.313.3.3 0 0 0-.024-.118l-.42-3.988a2.33 2.33 0 0 0 .899-1.832",
    "data-name": "Path 3828"
  })))))))))))));
};
export default SvgLock;